module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "DEDICATION _idGenParaOverride-1"
  }, [_vm._v("Dedicated to my wife Nancy,"), _c('br'), _vm._v("\tour three adult children, Mark, Amy, and Brian,"), _c('br'), _vm._v("\t\tand Rev. Mark A. Derby"), _c('br'), _vm._v("\t\t\tfor their ongoing participation in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("missio Dei")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-430468d7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Gorman_Becoming_the_Gospel_text_CC2.vue
// module id = 63
// module chunks = 0